<!-- 用户总览 -->
<template>
  <div>
    <matrix-statistics span="6" :list="statisticsList"></matrix-statistics>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card>
          <div class="title">
            <p>库存量分布</p>
          </div>
          <div id="analyse"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div class="title">
            <p>运输量分布</p>
          </div>
          <div id="trend"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-card style="height: 500px;margin-top: 20px">
      <div class="title" style="margin-bottom: 10px;">
        <p>库存详情</p>
        <div>
          <el-select v-model="value1" placeholder="客户类型" style="width: 106px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="value1" placeholder="合作状态" style="width: 106px;margin-left: 16px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="value1" placeholder="合作状态" style="width: 106px;margin-left: 16px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker v-model="value2" type="date" align="right" style="width: 158px;margin-left: 16px;">
          </el-date-picker>
          <el-button type="primary" icon="el-icon-search" style="margin-left: 16px;width: 98px;">搜索</el-button>
          <el-button icon="el-icon-refresh-left" style="margin-left: 16px;width: 98px;">重置</el-button>
        </div>
      </div>
      <avue-crud :data="data" :option="option" :page.sync="page">
        <template slot-scope="scope" slot="name1">
          <div style="display: flex;align-items: center;">
            <p style="margin-right: 10px;">{{ scope.row.name1 }}</p>
            <el-tag color="#DBEAFE" size="mini" v-if="scope.row.name6 == 2">重点</el-tag>
          </div>
        </template>
        <template slot-scope="scope" slot="name5">
          <el-link :underline="false" :type="scope.row.name6 == 2 ? 'success' : 'warning'">{{ scope.row.name5
            }}</el-link>
        </template>
        <template slot-scope="scope" slot="name6">
          <el-rate v-model="scope.row.name6" disabled></el-rate>
        </template>
        <template slot-scope="scope" slot="name7">
          <matrix-tag color="#166534" v-if="scope.row.name7 == 0" text="在园"></matrix-tag>
          <matrix-tag color="#1F2937" v-if="scope.row.name7 == 1" text="离园"></matrix-tag>
        </template>
        <template slot-scope="{row, index}" slot="menu">
          <i class="el-icon-view"></i>
        </template>
      </avue-crud>
    </el-card>
    <div style="height: 80px;"></div>
  </div>
</template>
<script>
import matrixTabs from '@/components/matrix/matrix-tabs'
import matrixStatistics from '@/components/matrix/matrix-statistics'
import matrixTag from '@/components/matrix/matrix-tag'

import * as echarts from 'echarts';

export default {
  name: "store-management/index/index",
  components: {
    matrixTabs,
    matrixStatistics,
    matrixTag
  },
  data() {
    return {
      statisticsList: [{
        label: '总客户数量',
        value: 258432,
        icon: 'el-icon-s-custom',
        iconColor: '#1F4287'
      }, {
        label: '本月活跃客户',
        value: 229718,
        icon: 'el-icon-data-line',
        iconColor: '#1F4287'
      }, {
        label: '在园区客户',
        value: 42156,
        icon: 'el-icon-s-order',
        iconColor: '#1F4287'
      }, {
        label: '月度交易总量',
        value: 15742,
        icon: 'el-icon-s-data',
        iconColor: '#1F4287'
      }],

      page: {
        pageSize: 10, // 每页显示10条
        currentPage: 1, // 第一页
        total: 3 // 总条数
      },
      data: [{
        name1: '山西煤运物流有限公司',
        name2: '运输公司',
        name3: '赵建国 (13987654321)',
        name4: '5 年',
        name5: '频繁',
        name6: 3,
        name7: 0,
      }, {
        name1: '河北诚信煤炭贸易有限公司',
        name2: '贸易商',
        name3: '李明远 (13876543210)',
        name4: '1 年',
        name5: '一般',
        name6: 2,
        name7: 1,
      }, {
        name1: '陕西大型钢铁集团',
        name2: '终端用户',
        name3: '王志强 (13765432109)',
        name4: '3 年',
        name5: '频繁',
        name6: 4,
        name7: 1,
      }],
      option: {
        header: false,
        editBtn: false,
        delBtn: false,
        height: '370px',
        menuWidth: '100px',
        column: [{
          label: '货主',
          prop: 'name1',
          width: 250
        }, {
          label: '企业类型',
          prop: 'name2',
          align: 'center'
        }, {
          label: '主要联系人',
          prop: 'name3',
          align: 'center',
          width: 180
        }, {
          label: '合作年限',
          prop: 'name4',
          align: 'center'
        }, {
          label: '近期交易',
          prop: 'name5',
          align: 'center'
        }, {
          label: '信用等级',
          prop: 'name6',
          align: 'center'
        }, {
          label: '当前状态',
          prop: 'name7',
          align: 'center'
        },]
      },
      value1: '',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value2: '2025-01-02'
    };
  },
  mounted() {
    this.trendInit()
    this.analyseInit()
  },
  methods: {
    trendInit() {
      let chartDom = document.getElementById('trend');
      let myChart = echarts.init(chartDom);
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {
          type: 'value',
          name: '吨',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          }
        },
        series: [
          {
            data: [820, 932, 1101, 1234, 1290, 1330],
            type: 'line',
            smooth: true,
            lineStyle: {
              color: '#2563EB',
              width: 2,
            },
            itemStyle: {
              color: '#2563EB',
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0.2,
                  color: 'rgba(37,99,235,0)'
                },
                {
                  offset: 1,
                  color: 'rgba(37,99,235,0.3)'
                }
              ])
            },

          }
        ]
      };
      option && myChart.setOption(option);
    },
    analyseInit() {
      let chartDom = document.getElementById('analyse');
      let myChart = echarts.init(chartDom);
      let option = {
        legend: {
          orient: 'vertial',
          right: 50,
          top: 140
        },
        series: [
          {
            type: 'pie',
            radius: ['45%', '70%'],
            right: 160,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 4
            },
            labelLine: {
              show: false
            },
            label: {
              show: false
            },
            data: [
              { value: 1048, name: '动力煤' },
              { value: 735, name: '烟煤' },
              { value: 580, name: '无烟煤' },
              { value: 220, name: '其他' },
            ]
          }
        ]
      };
      option && myChart.setOption(option);
    }
  }
};
</script>
<style scoped lang="scss">
#trend,
#analyse {
  width: 100%;
  height: 400px;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0;
  }
}

::v-deep .el-input__icon {
  line-height: 1 !important;
}
</style>
